import { Id } from "PFCore/types";

export const mutationKeys = {
  all: () => ["shortlists"],
  reset: (id?: Id) => [...mutationKeys.all(), "reset"].concat(id ? String(id) : []),
  reject: (id?: Id) => [...mutationKeys.all(), "reject"].concat(id ? String(id) : []),
  book: (id?: Id) => [...mutationKeys.all(), "book"].concat(id ? String(id) : []),
  fill: (id?: Id) => [...mutationKeys.all(), "fill"].concat(id ? String(id) : []),
  fillAndBook: (id?: Id) => [...mutationKeys.all(), "fillAndBook"].concat(id ? String(id) : []),
  assign: (id?: Id) => [...mutationKeys.all(), "assign"].concat(id ? String(id) : []),
  makeDecision: (id?: Id) => [...mutationKeys.all(), "makeDecision"].concat(id ? String(id) : []),
  create: () => [...mutationKeys.all(), "create"],
  update: () => [...mutationKeys.all(), "update"]
};
